import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1eca69f8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=1eca69f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eca69f8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Ware: require('/app/components/ware-view/ware.vue').default,ObserverHOC: require('/app/components/ObserverHOC/index.vue').default})
